import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-sso-callback',
  template: '<p>Signing you in.</p>'
})
export class SsoCallbackComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const code = params.get('code');
    const state = params.get('state');
    this.stripCodeFromAddressBar();

    const returnUrl = this.authService.takeSsoReturnUrl();
    if (!this.authService.consumeSsoState(state) || !code) {
      this.goToLogin(returnUrl);
      return;
    }

    this.authService.exchangeSso(code).subscribe({
      next: () => this.router.navigateByUrl(returnUrl),
      error: () => this.goToLogin(returnUrl)
    });
  }

  private goToLogin(returnUrl: string): void {
    this.router.navigate(['/login'], {
      queryParams: { sso: 'checked', returnUrl },
      replaceUrl: true
    });
  }

  private stripCodeFromAddressBar(): void {
    const url = new URL(window.location.href);
    url.searchParams.delete('code');
    url.searchParams.delete('state');
    const next = url.pathname + url.search + url.hash;
    window.history.replaceState({}, '', next);
  }
}
